import { RootAppState } from 'store/configureStore'

export const projectIsManufacturabilityCheckRunningSelector = (
  state: RootAppState
) => {
  return state.project?.projectOperations?.isManufacturabilityCheckRunning
}
